import React, { useEffect, useState } from 'react'
import { api } from '../../../app/Api/ApiSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../components/Loader'
import InfiniteScroll from 'react-infinite-scroll-component'
import moment from 'moment'


const StoreOrders = () => {
    const [orders, setOrders] = useState([])
    const [page, setPage] = useState(1)
    const [isLoading, setIsLoading] = useState(false)
    const [hasMore, setHasMore] = useState(false)

    const { name } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        const getOrders = async () => {
            try {
                setIsLoading(true)
                const response = await api(`/stores/${name}/manage/orders`, { params: { page } })
                // console.log(response)
                if (response) {
                    setIsLoading(false)
                    setOrders(response.data)
                }

            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getOrders()
    }, [])

    const handleRefresh = async () => { }
    return (
        <div className="store-user-carts-list">
            <h5>{name} Received Orders</h5>

            {isLoading && <Loader />}

            {!isLoading && orders.length === 0 && (
                <p className="not-found-msg">
                    {name} has no orders
                </p>
            )}

            {!isLoading && orders.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Order No</th>
                            <th>User</th>
                            <th>Acknowledged</th>
                            <th>Invoiced</th>
                            <th>Items</th>
                            <th>Total Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map(order => (
                            <tr
                                key={order._id}
                                onClick={() => navigate(`/b/manage/${name}/orders/${order._id}`,{state:{order}})}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{moment(order.createdAt).format("DD MM YYYY")}</td>
                                <td>{order.orderNo}</td>
                                <td>{order.createdBy.firstname} {order.createdBy.lastname}</td>
                                <td>{order.acknowledged?"yes":"no"}</td>
                                <td>{order.invoiced?"yes":"no"}</td>
                                <td>{order.items.length}</td>
                                <td>{order.totalAmount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    )
}

export default StoreOrders